$(document).ready(function () {
  if ($('.archive-filters').length) {
    if ($('.archive-filters').hasClass('v3')) {
      $('.filter-button').click(function () {
        $('.filter-button').removeClass('active');
        $(this).addClass('active');
        if($(this).hasClass('button-all')) {
          searchWorker.news_type(null);
        } else if($(this).hasClass('button-press')) {
          searchWorker.news_type(true);
        } else if($(this).hasClass('button-media')) {
          searchWorker.news_type(false);
        }
      });
    } else {
      $('button.filterby').click(function () {
        if ($('.archive-filters').hasClass('opened')) {
          $('.archive-filters').removeClass('opening');
          $('.archive-filters').removeClass('opened');
        } else {
          $('.archive-filters').addClass('opening');
          setTimeout(function () {
            $('.archive-filters').removeClass('opening');
            $('.archive-filters').addClass('opened');
          }, 500);
        }
      });
      var opitons = {
        itemSelectText: '',
        noChoicesText: '',
        removeItemButton: true,
        placeholder: true,
        searchEnabled: false,
      };
      var authorElement = document.getElementById('author');
      var productElement = document.getElementById('product');
      var audienceElement = document.getElementById('audience');
      var topicElement = document.getElementById('topic');
      if(authorElement) {
        window.autorChoises = new Choices(authorElement, opitons);
        authorElement.addEventListener('change', function (e) {
          searchWorker.author($(event.target).val());
        });

      }
      if(audienceElement) {
        window.audienceChoises = new Choices(audienceElement, opitons);
        audienceElement.addEventListener('change', function (e) {
          searchWorker.audience($(event.target).val());
        });
      }
      if(topicElement) {
        window.topicChoises = new Choices(topicElement, opitons);
        topicElement.addEventListener('change', function (e) {
          searchWorker.topic($(event.target).val());
        });
      }
      if(productElement) {
        window.productChoises = new Choices(productElement, opitons);
        productElement.addEventListener('change', function (e) {
          searchWorker.product($(event.target).val());
        });
      }
    }
    $('#filter-reset').on('click', function () {
      searchWorker.resetFilters();
    });
    $('#search-filter').on('keyup', function () {
      searchWorker.search($(this).val());
    });
  }
});